// src/theme/theme.js
import { createTheme } from "@mui/material/styles";

export const getTheme = (mode) => {
  return createTheme({
    palette: {
      mode,
      ...(mode === "light"
        ? {
            // Light mode colors
            primary: {
              main: "#2563EB",
              light: "#42a5f5",
              dark: "#003087",
            },
            secondary: {
              main: "#dc004e",
              light: "#ff4081",
              dark: "#c51162",
            },
            background: {
              default: "#f5f5f5",
              paper: "#ffffff",
            },
            text: {
              primary: "#111827",
              secondary: "#6b7280",
            },
          }
        : {
            // Dark mode colors
            primary: {
              main: "#3b82f6",
              light: "#60a5fa",
              dark: "#1d4ed8",
            },
            secondary: {
              main: "#f43f5e",
              light: "#fb7185",
              dark: "#be123c",
            },
            background: {
              default: "#000000",
              paper: "#0a0a0a",
            },
            text: {
              primary: "#E0E0E0",
              secondary: "#B0B0B0",
            },
          }),
    },
    typography: {
      fontFamily: "Roboto, Arial, sans-serif",
      h1: {
        fontWeight: 500,
        fontSize: "2.5rem",
      },
      h2: {
        fontWeight: 500,
        fontSize: "2rem",
      },
      h3: {
        fontWeight: 500,
        fontSize: "1.75rem",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 8,
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 12,
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
    },
  });
};
